import React from 'react';
import './EventDetail.css';
import { Link } from 'react-router-dom';
import { Event } from '../Event.interface';
import { environments } from 'environments/environments';
import PhotoDisplay from 'libs/components/PhotoDisplay/PhotoDisplay';
import { GalleryImage } from 'components/Main/PhotoSection/Gallery.interface';
import { FacebookIcon, FacebookShareButton, TwitterIcon, TwitterShareButton } from 'react-share';


export default class EventDetail extends React.Component {
  state = {
    event: {} as Event,
    error: false,
    posterDisplayed: false,
    loading: false
  }

  mounted = false;
  controller = new AbortController();

  componentDidMount() {
    this.mounted = true;
    this.getEvent();
  }

  componentWillUnmount() {
    this.mounted = false;
    this.controller.abort();
  }

  getDateFromURL(): { year: number, month: number, day: number } {
    const dateProps = (this.props as any).match.params || undefined;
    return {
      year: dateProps.year || 0,
      month: dateProps.month || 0,
      day: dateProps.day || 0
    }
  }

  getEvent() {
    const wanted = this.getDateFromURL();
    this.setState({ event: {}, loading: true, error: false });
    // console.log(wanted);

    const params = `?t=events&c=year=${wanted.year} AND month=${wanted.month} AND day=${wanted.day}&anticache=${Date.now()}`;
    fetch(environments.server + environments.backend + params, { signal: this.controller.signal })
      .then(async (result: any) => {
        const dbEvent = await result.json();
        if (dbEvent && dbEvent.length && dbEvent[0].id) {
          const event = dbEvent[0];
          event.guests = (event.guests || '').replace(/&quot;/g, '"').replace(/&apos;/g, '\'').split(';');
          this.setState({ event, error: false, loading: false });
        } else {
          this.setState({ event: {}, error: true, loading: false });
        }
      })
      .catch(e => {
        // console.error('Akce nebyla úspěšně načtena.\n', e);
        if (this.mounted) {
          this.setState({ event: {}, error: true, loading: false });
        }
      });
  }

  openImage() {
    this.setState({ posterDisplayed: true });
  }

  closeImage() {
    this.setState({ posterDisplayed: false });
  }

  makeEventName(event: Event) {
    let renderName = event.name || 'Doktor Triceratops';
    if (!event.name && (event.place || event.location)) {
      if (event.place && event.location) {
        renderName += ` - ${event.place} (${event.location})`;
      } else {
        renderName += ' - ' + (event.place || event.location);
      }
    }
    return renderName;
  }

  render() {
    const event = this.state.event
    const renderName = this.makeEventName(event).replace(/&quot;/g, '"').replace(/&apos;/g, '\'');
    const linkName = renderName.normalize('NFKD').replace(/[\u0300-\u036f]/g, "").replace(/[^\w]/g, '-');
    const shareURL = `${environments.server}/akce/${event.year}/${event.month}/${event.day}/${linkName}`
    const renderPoster = event.poster
      ? (
        <div className="event-poster">
          <img src={`${environments.server}${event.poster}`} alt={`${renderName}`} onClick={() => this.openImage()} />
        </div>
      )
      : null;
    const renderDay = event.weekday || '';
    const renderDate = `${event.day}. ${event.month}. ${event.year}`;
    const renderLocation = (event.location && event.place)
      ? (
        <div>
          <p className="event-info"><span className="event-info-left">Kde:</span>{event.place.replace(/&quot;/g, '"').replace(/&apos;/g, '\'')}</p>
          <p className="event-info"><span className="event-info-left"></span>{event.location.replace(/&quot;/g, '"').replace(/&apos;/g, '\'')}</p>
        </div>
      )
      : event.location
        ? (
          <div>
            <p className="event-info"><span className="event-info-left">Kde:</span>{event.location.replace(/&quot;/g, '"').replace(/&apos;/g, '\'')}</p>
          </div>
        )
        : event.place
          ? (
            <div>
              <p className="event-info"><span className="event-info-left">Kde:</span>{event.place.replace(/&quot;/g, '"').replace(/&apos;/g, '\'')}</p>
            </div>
          )
          : null;
    const renderFee = event.fee
      ? <p className="event-info"><span className="event-info-left">Vstup:</span>{event.fee}</p>
      : null;
    const renderGuests = event.guests && event.guests.length && event.guests.map((guest, index) => (
      <p key={index} className={"event-info" + (!index ? " event-guests" : "")}>
        <span className="event-info-left">
          {!index && guest
            ? 'Dále hrají:'
            : ''}
        </span>
        {guest}
      </p>
    ));
    /* If link exists, strip it of anything after national domain and add three dots and arrow.
    If link includes http, its 3 slashes, if not, its only 1 slash. */
    const linkRoot = (event.link && (event.link.split('/').slice(0, event.link.includes('http') ? 3 : 1).join('/') + '/... \u2192')) || '';
    const renderInfo = event.link && linkRoot
      ? (
        <p className="event-info event-guests">
          <span className="event-info-left">Více info:</span>
          <a href={event.link} target="_blank" rel="noopener noreferrer">{linkRoot}</a>
        </p>
      )
      : null;
    const isPast = (event.eventtime || 0) < Date.now();
    // const link = isPast ? "/akce/archiv" : "/akce"
    const image = {} as GalleryImage;
    if (this.state.event && this.state.event.id) {
      image.category = 'poster';
      image.filename = environments.server + this.state.event.poster || '';
      image.gallery = 0;
      image.width = this.state.event.posterwidth || 0;
      image.height = this.state.event.posterheight || 0;
      image.id = 0;
      image.order = 0;
      image.public = 1;
      image.text = '';
      image.time = Date.now();
    }

    const renderFrom = event.time && event.time !== '0:00 hod' && event.time !== '00:00 hod'
      ? (
        <p className="event-info">
          <span className="event-info-left">
            Od:
          </span>{event.time}
        </p>
      )
      : null;


    const renderDetail = (<div>

      <h2 className="event-header">
        {this.state.error
          ? <div className="error-message">Událost se nepovedlo načíst.</div>
          : <Link to={`/akce/${event.year}/${event.month}/${event.day}/${linkName}`}>{renderName}</Link>
        }
      </h2>
      {
        this.state.error ?
          <div className="event-details">
            Zkuste to později nebo vyzkoušejte jiný odkaz.
          </div> :
          <div className="event-details">
            {renderPoster}
            <div className="event-details-info">
              <p className="event-info"><span className="event-info-left">Kdy:</span>{renderDay} {renderDate}</p>
              {renderFrom}
              {renderLocation}
              {renderFee}
              {renderGuests}
              {renderInfo}
            </div>
            <p className="event-info event-text">{event.text}</p>
          </div>
      }
      {
        (this.state.posterDisplayed && image.filename)
          ? <PhotoDisplay activePhoto={0} photoList={[image]} close={this.closeImage.bind(this)} />
          : null
      }
    </div >
    );


    return (
      <div className="section event-detail">
        <Link to="/akce" className="event-link-back">&larr; Zpět na seznam akcí</Link>
        {isPast && !this.state.loading
          ? <span>
            &nbsp; / &nbsp;
            <Link to="/akce/archiv" className="event-link-back">do archivu</Link>
          </span>
          : null
        }
        {this.state.loading
          ? <p className='loading-info'><span className="loading loading-spinner"></span> Načítají se informace o akci...</p>
          : renderDetail
        }
        <div className="event-shares">
          <FacebookShareButton url={shareURL} hashtag="#doktortriceratops" className='share'>
            <FacebookIcon size={24} />Sdílet
          </FacebookShareButton>
          <TwitterShareButton url={shareURL} title={'\n'} hashtags={['doktortriceratops']} className="tweet">
            <TwitterIcon size={24} />Tweet
          </TwitterShareButton>
          {/* TODO - přidat "Copy link" */}
        </div>
      </div>
    );
  }
}
